import script from "./FormMediaComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FormMediaComponent.vue?vue&type=script&setup=true&lang=js"

import "./FormMediaComponent.vue?vue&type=style&index=0&id=fc5882f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc5882f6"]])

export default __exports__